export default "/images/vendor/flag-icon-css/flags/1x1/ni.svg?ef0b194fefa52dfa07ef5320ae142208";